/**
 * @file Utility functions for formatting and processing analytics data.
 */

/**
 * Interface for SAK questionnaire topic data
 */
export interface SakTopicData {
  topic?: string;
  response?: string;
}

/**
 * Extracts topic names from SAK questionnaire data and returns them as a comma-separated string.
 *
 * @param sakQuestionnaireData - An object or array of objects containing topic information
 * @returns A comma-separated string of topic names without spaces between commas
 * @example
 * // returns "Family,Pets"
 * formatSakTopics([{topic: "Family"}, {topic: "Pets"}])
 */
export const formatSakTopics = (
  sakQuestionnaireData: SakTopicData | SakTopicData[] | null | undefined
): string => {
  // Handle empty input
  if (!sakQuestionnaireData) {
    return "";
  }

  // Convert to array if it's a single object
  const dataArray = Array.isArray(sakQuestionnaireData)
    ? sakQuestionnaireData
    : [sakQuestionnaireData];

  // Extract topic names and filter out any empty values
  const topicNames = dataArray.map((item) => item?.topic).filter(Boolean);

  // Join with commas, no spaces
  return topicNames.join(",");
};
